module.exports = __webpack_public_path__ + "img/no_image.94c9be15.jpg";